import React, { useState, useEffect } from 'react'

interface TypewriterTextProps {
  text: string
  speed?: number
  onComplete?: () => void
  className?: string
}

export const TypewriterText: React.FC<TypewriterTextProps> = ({
  text,
  speed = 50,
  onComplete,
  className,
}) => {
  const [displayed, setDisplayed] = useState('')
  const [index, setIndex] = useState(0)
  const [done, setDone] = useState(false)

  useEffect(() => {
    // Reset when text changes
    setDisplayed('')
    setIndex(0)
    setDone(false)
  }, [text])

  useEffect(() => {
    if (done) return
    if (index >= text.length) {
      setDone(true)
      onComplete?.()
      return
    }

    const timer = setTimeout(() => {
      setDisplayed((prev) => prev + text[index])
      setIndex((prev) => prev + 1)
    }, speed)

    return () => clearTimeout(timer)
  }, [index, text, speed, done, onComplete])

  return (
    <span className={className}>
      {displayed}
      {!done && (
        <span
          className="cursor-blink"
          style={{ color: 'var(--accent-green)' }}
        >
          ▋
        </span>
      )}
    </span>
  )
}
